import { render, staticRenderFns } from "./CurrentOption.vue?vue&type=template&id=1bdc3027&"
import script from "./CurrentOption.vue?vue&type=script&lang=js&"
export * from "./CurrentOption.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports